// To do: make a class with private members

export const isBrowser = process.env.JEST_WORKER_ID ? false : typeof window !== 'undefined';
